import type { CSSProperties } from 'react';

/**
 * Bộ style cho menu/bảng hành động dạng "nút màu rời" (TCR-1238), dựng đầu tiên
 * cho menu "..." của trang Đơn hàng rồi dùng lại cho bảng hành động hàng loạt
 * của Đơn ECom. Để hằng số ở một chỗ vì hai màn phải trông giống hệt nhau —
 * chép màu sang từng file là kiểu trôi dạt âm thầm, sửa một bên quên bên kia.
 *
 * Đây CHỈ là style, không phải component dùng chung: `ActionColumn.tsx` vẫn giữ
 * nguyên vì nó phục vụ khoảng 35 bảng khác trong app.
 */
export type ActionTone = 'primary' | 'danger' | 'warning';

/**
 * Mọi hành động dùng chung một màu xanh dương; đỏ dành cho hành động huỷ/nguy
 * hiểm, cam dành cho hành động đảo ngược được nhưng làm lệch dòng chảy bình
 * thường của đơn (vd đánh dấu bỏ qua đơn).
 */
export const ACTION_TONE_STYLE: Record<ActionTone, { bg: string; color: string }> = {
  primary: { bg: '#1677ff', color: '#fff' },
  danger: { bg: '#cf1322', color: '#fff' },
  warning: { bg: '#fa8c16', color: '#fff' },
};

/** Nhãn nhóm in đậm màu đen để phân biệt khu vực. */
export const ACTION_GROUP_LABEL_STYLE: CSSProperties = { fontWeight: 700, color: '#000' };

/** Nút hành động: nền đặc, bo góc đều, icon bên trái, chữ trắng. */
export function actionButtonStyle(tone: ActionTone, disabled = false): CSSProperties {
  const { bg, color } = ACTION_TONE_STYLE[tone];
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 10px',
    borderRadius: 6,
    background: bg,
    color,
    fontWeight: 600,
    fontSize: 13,
    opacity: disabled ? 0.45 : 1,
  };
}

/** Ghi chú chặn thao tác — phải đập vào mắt, không để lẫn thành chữ phụ màu xám. */
export const BLOCKING_NOTE_STYLE: CSSProperties = {
  display: 'block',
  fontSize: 12,
  color: '#ad4e00',
  background: '#fff7e6',
  border: '1px solid #ffd591',
  borderRadius: 6,
  padding: '6px 8px',
  lineHeight: 1.35,
};

/**
 * Nút xếp dọc dùng chung bộ màu với menu hành động của trang Đơn hàng; panel hẹp
 * nên chữ phải tự xuống dòng thay vì bị cắt.
 */
export function blockButtonStyle(tone: ActionTone = 'primary'): CSSProperties {
  return {
    ...actionButtonStyle(tone),
    // `.ant-btn` ép `justify-content: center`; menu trang Đơn hàng là <span> nên
    // mặc định căn trái — phải đè lại để hai màn trông giống nhau.
    justifyContent: 'flex-start',
    width: '100%',
    height: 'auto',
    minHeight: 28,
    whiteSpace: 'normal',
    textAlign: 'left',
    lineHeight: 1.3,
    border: 'none',
  };
}
